import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Skeleton, VerticalSpace } from '@arc-ui/components';
import { LoadingSpinnerProps } from '../../../types';
import { SizeToSkeletonCount } from '../../../constants';

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  ariaLabel = 'Loading',
}) => {
  const skeletonCount = SizeToSkeletonCount[size] ?? 4;

  const spinnerKeys = useMemo(
    () => Array.from({ length: skeletonCount }, () => uuidv4()),
    [skeletonCount],
  );

  return (
    <output data-testid="loading-spinner" aria-label={ariaLabel}>
      {spinnerKeys.map((key) => (
        <div key={key}>
          <Skeleton height={18} animation="pulse" />
          <VerticalSpace size="8" />
        </div>
      ))}
    </output>
  );
};
